const rankingItems = [
  { rank: 1, title: '某顶流小生深夜密会神秘女子', hot: '🔥 9.8万', change: 'up' },
  { rank: 2, title: '知名女星婚变内幕第三者曝光', hot: '🔥 7.2万', change: 'up' },
  { rank: 3, title: '网红主播偷税漏税被查', hot: '🔥 6.5万', change: 'same' },
  { rank: 4, title: '综艺录制现场嘉宾爆发冲突', hot: '5.3万', change: 'up' },
  { rank: 5, title: '男团成员私联粉丝聊天记录泄露', hot: '4.8万', change: 'down' },
  { rank: 6, title: '知名导演涉嫌潜规则新人演员', hot: '3.1万', change: 'up' },
  { rank: 7, title: '华语乐坛抄袭风波对比分析', hot: '2.6万', change: 'new' },
];

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-primary-400 text-background-50',
  3: 'bg-accent-500 text-background-50',
};

const changeIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-600',
  down: 'ri-arrow-down-line text-foreground-400',
  same: 'ri-subtract-line text-foreground-400',
  new: 'ri-sparkling-line text-primary-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          热度榜单
        </h2>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 border border-secondary-200/60 rounded-2xl overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-primary-50/50 transition-colors ${
                  idx < rankingItems.length - 1 ? 'border-b border-secondary-100/60' : ''
                }`}
              >
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                    rankColors[item.rank] || 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                </div>
                <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.hot}</span>
                <span className="flex-shrink-0">
                  <i className={changeIcons[item.change]}></i>
                </span>
              </div>
            ))}
          </div>
          <p className="text-center text-xs text-foreground-400 mt-4">
            榜单基于站内阅读量、讨论度综合计算，每2小时更新
          </p>
        </div>
      </div>
    </section>
  );
}